import data from "../../../../../src/TextInput.docs.json";
import * as React from 'react';
export default {
  data,
  React
};